<div class="containerMarginX">
  <div class="principal-wrapper" *ngIf="isLoading; else elseBlock">
    <tech-back class="ml-2"></tech-back>
    <div class="card-white">
      <h2 class="title">{{ 'k002547' | translate }}</h2>

      <div class="content-type">
        {{ 'k002489' | translate }}
        <span class="blue2 bold">{{ profileName }}</span>
      </div>

      <div class="profile-description" *ngIf="profileSelected">
        <img
          src="./assets/img/{{ customTheme }}/questionnaire/investor/0{{
            profileSelected.id
          }}.png"
          alt=""
          class="img-profile"
        />

        <div>
          <div class="content-profile">
            {{ profileSelected.description }}
          </div>

          <p
            class="content-profile-expired"
            [class.negative]="isReprofileExpired"
          >
            {{ expireReProfile }}
          </p>
        </div>
      </div>

      <tech-questions-result2
        [testId]="testId"
        *ngIf="extendedTest"
      ></tech-questions-result2>

      <div class="blue2 profile-description-02">
        {{ 'k002548' | translate }}
      </div>
    </div>

    <div class="principal-btn">
      <button
        type="button"
        mat-flat-button
        class="buttonPortal lg my-4"
        (click)="goToRetake()"
        color="blue"
        disabled="{{ !isReprofile }}"
      >
        {{ 'k000666' | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #elseBlock>
  <div class="loading-spinner">
    <tech-loading-peq></tech-loading-peq>
  </div>
</ng-template>
